import React, { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { getStatusIcon, formatDateRange } from '../../utils/autoplanner/taskUtils';
import TaskStatus from './TaskStatus';
import TaskActions from './TaskActions';
import TaskDetails from './TaskDetails';
import {
  ClockIcon,
  CheckCircleIcon,
  XCircleIcon,
  ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

const TaskListItem = ({ task, onEditTask, onDeleteTask, isDeleting }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="p-4 sm:p-6">
      <div className="flex flex-col space-y-3 sm:flex-row sm:items-center sm:justify-between sm:space-y-0">
        <div className="flex min-w-0 flex-1 items-center space-x-3">
          <button
            onClick={toggleExpansion}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600"
          >
            {isExpanded ? (
              <ChevronDownIcon className="h-5 w-5" />
            ) : (
              <ChevronRightIcon className="h-5 w-5" />
            )}
          </button>
          <div className="flex min-w-0 flex-1 items-center space-x-3">
            {(() => {
              const iconType = getStatusIcon(task.status);
              switch (iconType) {
                case 'clock-yellow':
                  return <ClockIcon className="h-5 w-5 flex-shrink-0 text-yellow-500" />;
                case 'check-green':
                  return <CheckCircleIcon className="h-5 w-5 flex-shrink-0 text-green-500" />;
                case 'clock-blue-spin':
                  return <ClockIcon className="h-5 w-5 flex-shrink-0 animate-spin text-blue-500" />;
                case 'x-red':
                  return <XCircleIcon className="h-5 w-5 flex-shrink-0 text-red-500" />;
                case 'x-gray':
                  return <XCircleIcon className="h-5 w-5 flex-shrink-0 text-gray-400" />;
                case 'exclamation-gray':
                default:
                  return (
                    <ExclamationTriangleIcon className="h-5 w-5 flex-shrink-0 text-gray-400" />
                  );
              }
            })()}
            <div className="min-w-0 flex-1">
              <h4 className="truncate text-sm font-medium text-gray-900">
                {task.training_group?.name || 'Unknown Training Group'}
              </h4>
              <p className="truncate text-sm text-gray-500">
                Created by {task.user?.first_name} {task.user?.last_name}
              </p>
            </div>
          </div>
        </div>

        <div className="hidden flex-shrink-0 items-center space-x-4 md:flex">
          <TaskStatus status={task.status} />
          <div className="text-sm text-gray-500">
            {formatDateRange(task.start_date, task.end_date)}
          </div>
          <div className="flex items-center space-x-2">
            <TaskActions
              task={task}
              onEditTask={onEditTask}
              onDeleteTask={onDeleteTask}
              isDeleting={isDeleting}
            />
          </div>
        </div>

        {/* Mobile layout */}
        <div className="space-y-2 md:hidden">
          <div className="text-xs text-gray-500">
            {formatDateRange(task.start_date, task.end_date)}
          </div>
          <div className="flex items-center justify-end space-x-2">
            <TaskActions
              task={task}
              onEditTask={onEditTask}
              onDeleteTask={onDeleteTask}
              isDeleting={isDeleting}
            />
          </div>
        </div>
      </div>

      {isExpanded && <TaskDetails task={task} onEditTask={onEditTask} />}
    </div>
  );
};

export default TaskListItem;
